import { DateRange } from '../../enums/date/date-range.enum';

export const DateRangeTranslationMapper = new Map<DateRange, string>([
  [DateRange.AllTime, 'DATE_RANGE.ALL_TIME'],
  [DateRange.LastYear, 'DATE_RANGE.LAST_YEAR'],
  [DateRange.LastMonth, 'DATE_RANGE.LAST_MONTH'],
  [DateRange.LastWeek, 'DATE_RANGE.LAST_7_DAYS'],
  [DateRange.CurrentMonth, 'DATE_RANGE.CURRENT_MONTH'],
]);
